import React, { Fragment,Component } from 'react';
import sgen_screen from '../images/sgen_snap01.png';
import '../../App.css';
import { Link } from 'react-router-dom';
import openai from '../images/OpenAI_Logo.png'

class SGEN extends Component {

    static defaultProps = {
        title: 'Script Generator',
        icon: 'fas fa-cogs'

    }

    render() {
        return (
            <Fragment>
            <div>
                <img src={sgen_screen} alt="ScriptGenerator"/>
          </div>
          <div className="body-container">
            <div className="CenteredTitle">Script Generator (SGEN [es-jen])</div><br/>
            <div className="text-center">Script Generator allows users to easily create test scripts and view them in a table view for easy sharing.<br/> With our easy to use interface, SGEN helps you create a test suite with minimum effort.<br/>
                Try it today and see how easy it can be to create your next test suite.
                <br/><br/>
                Now Powered by 
                <div className="all-center ">
                <div className="img-container-med"><img src={openai} alt="openAI"/></div>
                </div>
                <br/><br/>
                <a href="http://sgen.mytestingtools.com/">Let's write some test cases!</a>   
                <br/><br/><Link to="/documentation">Teach me how to use the tool!</Link><br/><br/>
            </div>
          </div>
          </Fragment>
        )
    }
}

export default SGEN



// WEBPACK FOOTER //
// ./src/components/layout/SGEN.js